module.exports = __webpack_public_path__ + "img/green3_sl.32fe7890.svg";